<template>
    <div class="comp-launch-app">
        <div class="app-box" @click="openOrDownloadApp">
            <slot></slot>
        </div>
        <div class="mask" v-if="isShowOpenBrowser === true" @click="isShowOpenBrowser = false">
            <div class="arrow">
                <img src="../image/arrow-icon.png" alt="">
            </div>
            <div class="arrow-text">
                <p>{{messages[language].openInBrowser}}</p>
            </div>
        </div>
    </div>
</template>
<script>

    //ios 通用链接地址
    // let iosAppUrl = "https://tweebaa.com/space";
    let iosAppUrl = 'https://tweebaa.com/space/html/weixin.html';

    //安卓 scheme启动地址
    let androidAppUrl = "tweebaa6015637724215://";

    //AppStore下载地址
    var iosAppStore = "https://apps.apple.com/us/app/tweebaa/id1467778439";

    //安卓apk下载地址
    const androidApk = "https://tweebaafiles.oss-cn-beijing.aliyuncs.com/archive/app/tweebaa.apk";

    //应用宝下载地址
    const appQQ = "https://a.app.qq.com/o/simple.jsp?pkgname=cn.charity.tweebaa";

    var browser = {
        versions: function () {
            var u = navigator.userAgent,
                app = navigator.appVersion;
            return { //移动终端浏览器版本信息
                weixin: u.match(/MicroMessenger/i) == 'MicroMessenger',//是否为微信浏览器
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
                iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                qq: u.match(/\sQQ/i) !== null, //是否QQ
                //Safari: u.indexOf('Safari') > -1,//Safari浏览器,
                baidu: u.indexOf('baidu') > 0
            };

        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };

    /**

     * 版本检测

     * @method detectVersion 版本检测

     * @return {返回值类型} isAndroid, isIOS, isIOS9 true或false

     */

    function detectVersion() {

        let isAndroid, isIOS, isIOS9, version,

            u = navigator.userAgent,

            ua = u.toLowerCase();

        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {  //android终端或者uc浏览器

            //Android系统

            isAndroid = true

        }

        if (ua.indexOf("like mac os x") > 0) {

            //ios

            var regStr_saf = /os [\d._]*/gi;

            var verinfo = ua.match(regStr_saf);

            version = (verinfo + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");

        }

        var version_str = version + "";

        if (version_str != "undefined" && version_str.length > 0) {

            version = parseInt(version)

            if (version >= 8) {

                // ios9以上

                isIOS9 = true

            }

            else {

                isIOS = true

            }

        }

        return { isAndroid, isIOS, isIOS9 }

    }

    /**

     * 判断手机上是否安装了app，如果安装直接打开url，如果没安装，执行callback

     * @method openApp 打开App

     * @param {参数类型} url 启动app地址

     * @param {参数类型} callback 回调地址app(下载地址)

     * @return {返回值类型} 返回值说明

     */

    function openApp(url, callback) {

        let {isAndroid, isIOS, isIOS9} = detectVersion();

        if (isAndroid || isIOS) {
            var timeout, t = 2000, hasApp = true;

            var openScript = setTimeout(function () {

                if (!hasApp) {

                    callback && (window.location.href = callback);

                }

                document.body.removeChild(ifr);

            }, 3000);

            var t1 = Date.now();

            var ifr = document.createElement("iframe");

            ifr.setAttribute('src', url);

            ifr.setAttribute('style', 'display:none');

            document.body.appendChild(ifr);

            timeout = setTimeout(function () {

                var t2 = Date.now();

                if (t2 - t1 < t + 100) {

                    hasApp = false;

                }

            }, t);
        }

        // alert('isIOS9: ' + isIOS9);

        if (isIOS9) {

            // alert('url: ' + url);

            location.href = url;

            // setTimeout(function () {
            //
            //     callback && (window.location.href = callback);
            //
            // }, 250);
            //
            // setTimeout(function () {
            //
            //     location.reload();
            //
            // }, 1000);

        }

    }

    export default {
        name: 'LaunchApp',
        data() {
            return {
                messages: {
                    en: {
                        openInBrowser: 'Please click the menu and select "Open in Browser"',
                    },
                    zh: {
                        openInBrowser: '请在菜单中选择"在浏览器打开"',
                    },
                },
                isShowOpenBrowser: false,    // 是否提示用浏览器打开
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
            params: {
                type: String,
                default: ''
            }
        },
        watch: {

        },
        methods: {
            openOrDownloadApp() {
                if (!this.type) {
                    // alert('The type is must');
                    throw new Error('The type is must');
                }

                // 处理参数
                let [html, params] = window.location.href.split('?');
                let androidAppUrlNew;
                let iosAppUrlNew;

                if (this.params) {
                    params = this.params;
                }

                var vars = this.$util.getUrlVars();

                if (params) {
                    androidAppUrlNew = androidAppUrl + '?' + params + '&type=' + this.type;
                    iosAppUrlNew = iosAppUrl + '?' + params + '&type=' + this.type  + '&shareid=' + (vars['shareid'] || vars['invitecode']);
                } else {
                    androidAppUrlNew = androidAppUrl + '?' + 'type=' + this.type;
                    iosAppUrlNew = iosAppUrl + '?' + 'type=' + this.type + '&shareid=' + (vars['shareid'] || vars['invitecode']);
                }

                // console.log('androidAppUrlNew: ' + androidAppUrlNew);
                // console.log('iosAppUrlNew: ' + iosAppUrlNew);

                // 微信安卓，展示遮罩，引导用户去浏览器打开
                if (browser.versions.weixin && browser.versions.android) {
                    // alert("微信安卓");
                    // let encodeUri = encodeURIComponent(androidAppUrlNew);
                    // alert('encodeUri: ' + encodeUri);
                    // window.location.href = appQQ + '&android_schema=' + encodeUri;

                    // openApp(appQQ);
                    this.isShowOpenBrowser = true;
                }

                else if (browser.versions.android && browser.versions.webKit) { //安卓

                    openApp(androidAppUrlNew, iosAppUrlNew);

                }

                else if (browser.versions.weixin && (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad)) { //微信IOS

                    // alert("微信IOS");

                    openApp(iosAppUrlNew);

                }

                else if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) { //IOS

                    // alert("IOS");

                    // location.href = appQQ;

                    // 如果是QQ，先直接使用Scheme，而不是通用链接，尽管Scheme也不好使
                    // if (browser.versions.qq) {
                    //     openApp(androidAppUrlNew, iosAppStore);
                    //     return;
                    // }

                    if (this.$util.language === 'zh') {
                        iosAppStore = iosAppStore + '?l=zh&ls=1';
                    }

                    openApp(iosAppUrlNew, iosAppStore);

                    // location.href = iosAppUrlNew;

                    // openApp(iosAppUrlNew, iosAppStore);

                }

            }
        }
    }
</script>
<style lang="less">
    .comp-launch-app {
        .mask {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.75);
            z-index: 9999;

            .arrow {
                width: 88px;
                height: 125px;
                position: absolute;
                top: 8px;
                right: 30px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .arrow-text {
                position: absolute;
                top: 150px;
                left: 50%;
                width: 100%;
                transform: translate(-50%, 0);
                font-size: 16px;
                text-align: center;
                color: #fff;
            }

            .img {
                width: 50px;
                height: 50px;
                float: right;
            }
            .info {
                width: 100%;
                text-align: center;
                padding-top: 2rem;
                clear: both;
                .info-text {
                    font-size: 18px;
                    font-weight: 700
                }
            }
        }
    }
</style>
